import { AwbHistoryDataInterface } from "../../../../redux/interfaces/general.interface";
import { useAppDispatch } from "../../../../redux/hooks";
import {
  fetchPrintAwbA4,
  fetchPrintAwbZebra,
} from "../../../../redux/api/expedition.api";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";

function AwbHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: AwbHistoryDataInterface;
}) {
  const dispatch = useAppDispatch();

  const handlePrintAwbA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintAwbA4({
          idDocTrans: itemId,
        }),
      );
    }
  };

  const handlePrintAwbZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintAwbZebra({
          idDocTrans: itemId,
        }),
      );
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`AWB ${crudData.doc_trans}`}
      ariaLabel={`Actiuni pentru AWB ${crudData.doc_trans}`}
      items={[
        {
          id: "print-a4",
          label: "Print A4",
          icon: "PRINT_A4",
          kind: "print",
          tooltip: "Deschide etichetele AWB in format PDF A4.",
          onClick: handlePrintAwbA4,
        },
        {
          id: "print-zebra",
          label: "Print Zebra",
          icon: "PRINT_ZEBRA",
          kind: "print",
          tooltip: "Pregateste etichetele AWB pentru imprimare Zebra.",
          onClick: handlePrintAwbZebra,
        },
      ]}
    />
  );
}

export default AwbHistoryActionButtons;
